import { createSelector } from '@ngrx/store';
import { selectFeature } from '../../store/admin.selectors';

const selectIntegrationEventLogsFeature = createSelector(
    selectFeature,
    (state) => state.integrationEventLogDetailsState
);

export const selectEventLogDetails = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails
);

export const selectEventLogIsLoading = createSelector(selectIntegrationEventLogsFeature, (state) => state.isLoading);

export const selectEventLogInputData = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.inputData
);

export const selectEventLogSuccessRecords = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.successRecords
);

export const selectEventLogSuccessData = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.successRecords?.map((record) => record.item2) || []
);

export const selectEventLogUnmodifiedRecords = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.unmodifiedRecords
);

export const selectEventLogUnmodifiedData = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.unmodifiedRecords?.map((record) => record.item2) || []
);

export const selectEventLogErrorRecords = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.errorRecords
);

export const selectEventLogIntegrationVersion = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.eventLogDetails.integrationVersion
);

export const selectRecordLogsDetails = createSelector(selectIntegrationEventLogsFeature, (state) => state.recordLogs);

export const selectRecordLogsFound = createSelector(
    selectRecordLogsDetails,
    (recordLogs) => recordLogs?.found ?? false
);

export const selectRecordLogsInputData = createSelector(
    selectRecordLogsDetails,
    (recordLogs) => recordLogs?.inputData ?? null
);

export const selectRecordLogsLogs = createSelector(selectRecordLogsDetails, (recordLogs) => recordLogs?.logs ?? []);

export const selectRecordLogsChanges = createSelector(
    selectRecordLogsDetails,
    (recordLogs) => recordLogs?.changes ?? []
);

export const selectRecordLogsErrors = createSelector(selectRecordLogsDetails, (recordLogs) => recordLogs?.errors ?? []);

export const selectRecordLogsLoading = createSelector(
    selectIntegrationEventLogsFeature,
    (state) => state.isRecordLogsLoading
);
